import { colorsList } from "../../data/colorsList";
import { isEditor } from "../../functions/isEditor";

export default function MenuBar({
  menuList,
  viewButtonsList = [],
  boundaryInfo,
  viewList,
}) {
  const maxHeight =
    menuList.filter((e) => e.active).length * 55 +
    (isEditor &&
    boundaryInfo.active &&
    (boundaryInfo.data?.id || boundaryInfo.isEmpty)
      ? 35
      : 0);
  viewButtonsList = viewButtonsList.filter((e) => e.active);
  const viewWidth = viewList.active ? viewButtonsList.length * 45 : 0;
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 106,
          right: 70,
          height: 45,
          width: viewWidth,
          opacity: viewList.active ? 1 : 0,
          zIndex: 100,
          display: "flex",
          flexDirection: "row",
          gap: 10,
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
          transition: "width 0.5s, opacity 0.5s",
        }}
      >
        {viewButtonsList.map(({ Container, style, ...rest }, index) => {
          return (
            <Container
              key={index}
              iconSize={30}
              shadow={true}
              color={colorsList.white}
              {...rest}
              style={{ width: 35, height: 35, ...style }}
            />
          );
        })}
      </div>

      <div
        style={{
          position: "absolute",
          // backgroundColor: "red",
          width: 45,
          paddingRight: 10,
          paddingBottom: 10,
          right: 15,
          top: 100,
          bottom: 80,
          zIndex: 100,
          display: "flex",
          maxHeight,
          flexDirection: "column",
          gap: 10,
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
          transition: "max-height 0.5s",
        }}
      >
        {menuList
          .filter((e) => e.active)
          .map(({ Container, active, style = {}, ...rest }, index) => {
            return (
              <Container
                key={index}
                iconSize={40}
                shadow={true}
                style={style}
                {...rest}
              />
            );
          })}
      </div>
    </>
  );
}
